import { createOutlineIcon } from "../createIcon";

export const CheckOutlineIcon = createOutlineIcon(
  <>
    <path d="M16.7992 8.3999L9.6397 15.5999L7.19922 13.1456" />
  </>,
  "CheckOutlineIcon"
);
